import * as React from 'react';
import { compose, setDisplayName, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin } from 'ui/styles/skin';
import { modal } from 'ui/shared/modal';
import { Button } from 'ui/shared/Button';

import './SensitivityHelpDialog.css';

export type OwnProps = {
    visible: boolean;
    onClose: () => void;
};

const buttonStyle: React.CSSProperties = {
    float: 'right',
};

const TextBlock = ({ textKey, t }: { textKey: string } & TranslateProps) =>
    <p
        dangerouslySetInnerHTML={
            { __html: t(textKey).replace(/\\n/g, '<br/>') }
        }
    />
;


const RawSensitivityHelpDialog = ({ onClose, handleKeyDown, t }: OwnProps & RecomposeProps & TranslateProps) =>
    <div
        onKeyDownCapture={ handleKeyDown }
    >
        <Button
            id="sensitivity-help-close-button-1"
            onClick={ onClose }
            style={ buttonStyle }
            textKey="289"
            autoFocus={ true }
        />
        
        <h2>
            { t('WC_HELP_SENSITIVITY_INTERSECTIONS_TITLE') }
        </h2>
        <TextBlock textKey="WC_HELP_SENSITIVITY_INTERSECTIONS_BODY" t={ t }/>

        <h2>
            { t('WC_HELP_SENSITIVITY_MIN_MAX_INTERSECTIONS_TITLE') }
        </h2>
        <TextBlock textKey="WC_HELP_SENSITIVITY_MIN_MAX_INTERSECTIONS_BODY" t={ t }/>

        <h2>
            { t('WC_HELP_SENSITIVITY_DWELL_TIME_TITLE') }
        </h2>
        <TextBlock textKey="WC_HELP_SENSITIVITY_DWELL_TIME_BODY" t={ t }/>

        <h2>
            { t('WC_HELP_SENSITIVITY_MIN_MAX_DWELL_TIME_TITLE') }
        </h2>
        <TextBlock textKey="WC_HELP_SENSITIVITY_MIN_MAX_DWELL_TIME_BODY" t={ t }/>

        <h2>
            { t('WC_HELP_SENSITIVITY_DWELL_THRESHOLD_TITLE') }
        </h2>
        <TextBlock textKey="WC_HELP_SENSITIVITY_DWELL_THRESHOLD_BODY" t={ t }/>

        <Button
            id="sensitivity-help-close-button-2"
            onClick={ onClose }
            style={ buttonStyle }
            textKey="289"
        />
    </div>
;

type RecomposeProps = {
    handleKeyDown: React.KeyboardEventHandler<HTMLDivElement>;
};
export const SensitivityHelpDialog = compose<OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('SensitivityHelpDialog'),
    skin,
    translate(),
    withHandlers({
        handleKeyDown: ({ visible, onClose }: OwnProps) => (e: React.KeyboardEvent<HTMLDivElement>) => {
            if (visible && e.key === 'Escape') {
                onClose();
            }
        },
    }),
    modal('sensitivity-help-dialog'),
)(RawSensitivityHelpDialog);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/sensitivity/SensitivityHelpDialog.tsx